import { useState, useCallback } from 'react';
import axios from 'axios';

export const PROVIDER_STATUS = {
    NO_RESULT: 'no-result',
    FOUND: 'found',
    NOT_FOUND: 'not-found'
};

export const useProviderCheck = () => {
    const [providerState, setProviderState] = useState({
        checkPostalCode: "",
        availablePostalAreas: [],
        selectedPostalAreaId: undefined,
        checkProvider: {},
        checkProviderResult: PROVIDER_STATUS.NO_RESULT,
        postalArea: undefined,
        showPostCodeError: false,
    });

    const getPostalCode = useCallback(async (postalCode) => {
        if (!postalCode) {
            return;
        }
        
        try {
            const response = await axios.get(`api/postalarea/getpostalareabypostalcode?postCode=${postalCode}`);
            
            if (!response.data?.data) {
                setProviderState(prev => ({
                    ...prev,
                    availablePostalAreas: [],
                    selectedPostalAreaId: undefined,
                    showPostCodeError: true
                }));
                
                window.dataLayer.push({
                    "event": "message",
                    "message": `postal code invalid - ${postalCode}`
                });
                return false;
            }
            
            setProviderState(prev => ({
                ...prev,
                availablePostalAreas: response.data.data,
                selectedPostalAreaId: response.data.data[0].id,
                showPostCodeError: false
            }));
            
            window.dataLayer.push({
                "event": "message",
                "message": `postal code valid - ${postalCode}`
            });
            return true;
        } catch {
            setProviderState(prev => ({
                ...prev,
                availablePostalAreas: [],
                selectedPostalAreaId: undefined,
                showPostCodeError: true
            }));
            
            window.dataLayer.push({
                "event": "message",
                "message": `postal code invalid - ${postalCode}`
            });
            return false;
        }
    }, []);

    const checkProvider = useCallback(async (serviceId, postalAreaId) => {
        try {
            const response = await axios.get(
                `api/provider/getbypostalcodeservicewithhighestscore?serviceId=${serviceId}&postalAreaId=${postalAreaId}`
            );
            
            setProviderState(prev => {
                const selectedArea = prev.availablePostalAreas.find(
                    x => x.id === parseInt(postalAreaId)
                );
                
                return {
                    ...prev,
                    checkProvider: response.data.data,
                    checkProviderResult: (!response.data?.data || response.data?.data.isError) 
                        ? PROVIDER_STATUS.NOT_FOUND 
                        : PROVIDER_STATUS.FOUND,
                    postalArea: selectedArea,
                    showPostCodeError: false
                };
            });
            
            return response.data.data;
        } catch {
            setProviderState(prev => ({
                ...prev,
                checkProvider: undefined,
                checkProviderResult: PROVIDER_STATUS.NOT_FOUND,
                postalArea: undefined,
                showPostCodeError: true
            }));
            return null;
        }
    }, []);

    const updatePostalCode = useCallback((value) => {
        setProviderState(prev => ({ ...prev, checkPostalCode: value }));
    }, []);

    const updateSelectedArea = useCallback((areaId) => {
        setProviderState(prev => ({ ...prev, selectedPostalAreaId: areaId }));
    }, []);

    const resetProviderCheck = useCallback(() => {
        setProviderState({
            checkPostalCode: "",
            availablePostalAreas: [],
            selectedPostalAreaId: undefined,
            checkProvider: {},
            checkProviderResult: PROVIDER_STATUS.NO_RESULT,
            postalArea: undefined,
            showPostCodeError: false,
        });
    }, []);

    return {
        providerState,
        getPostalCode,
        checkProvider,
        updatePostalCode,
        updateSelectedArea,
        resetProviderCheck,
        setProviderState
    };
};
